﻿define('lq/events/actions/mapping',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq/entityFiltersState',
    'lq/types',
    'lq/asyncSubcriptions'
], function (_, EventAction, entityFiltersState, types, asyncSubcriptions) {
    'use strict';

    function Mapping(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    	this.mapping = eventData.mapping;
    }

    EventAction.extend(Mapping, EventAction);

    Mapping.typeName = 'Mapping';

    Mapping.prototype.getBatchType = function () {
        return this.mapping.type === 'DataSource' && (!this.mapping.dataSource.async || this.mapping.dataSource.initialDataSource)
            ? EventAction.QUERY_BATCH
            : EventAction.DO_NOT_BATCH;
    };

    Mapping.prototype.createEventActionRequest = function () {
        if (this.getBatchType() === EventAction.DO_NOT_BATCH)
            return undefined;

        return {
            eventActionType: 'ExecuteMapping',
            mappingsId: this.mapping.mappingsId,
            mappingName: this.mapping.mappingName
        };
    };

    Mapping.prototype.execute = function (continuation, eventActionResponse) {
        if (this.mapping.type === 'DataSource') {
            if (eventActionResponse)
                this._doMappingFromDataSource(eventActionResponse);

            if (this.mapping.dataSource.async) {
                asyncSubcriptions
                    .addDatasourceSubscription(
                        this.piping,
                        this.mapping.dataSource.id,
                        this.mapping.dataSource.filter,
                        this.receiveAsyncData.bind(this))
                    .then(continuation);
            } else {
                continuation();
            }

    	} else if (this.mapping.type === 'Parameter') {
            this._doMappingFromParameter();
            continuation();
    	} else if (this.mapping.type === 'ViewModel') {
            this._doMappingFromViewModel();
            continuation();
	    } else if (this.mapping.type === 'QueryString') {
            this._doMappingFromQueryString();
            continuation();
	    } else if (this.mapping.type === 'FixedValue') {
            this._doMappingFromFixedValue();
            continuation();
        } else if (this.mapping.type === 'NullValue') {
            this._doMappingFromNullValue();
            continuation();
    	} else {
    		throw new Error('Unknown type of mapping encountered');
        }
    };

    Mapping.prototype.receiveAsyncData = function (eventName, data) {
        if (eventName === 'receiveResults') {
            this._doMappingFromDataSource({
                queryResult: data
            })
        }
    };

    Mapping.prototype._doMappingFromDataSource = function (eventActionResponse) {
        var self = this;

        var queryResult = eventActionResponse.queryResult;
        _.each(this.mapping.fields, function (field) {
            var aResult = queryResult.results[0];

            if (field.target === 'EntityFilters') {
                entityFiltersState.restoreStateOfFilters(self.rootDrop, aResult[field.sourceOutput]);
            } else if (field.targetViewModelKey) {
                var targetMorph = self.piping.dropFactory.findDropByViewModelKey(field.targetViewModelKey);
                if (targetMorph) {
                    if (aResult === null || aResult === undefined || aResult === NaN || aResult === '') {
                        targetMorph.clearValue();
                    } else {
                        if (targetMorph.supportsManyToManyData()) {
                            targetMorph.setValue({
                                type: queryResult.outputs[field.sourceOutput],
                                value: _.map(queryResult.results, function(aResult) {
                                    return aResult[field.sourceOutput];
                                })
                            });
                        } else {
                            targetMorph.setValue({
                                type: queryResult.outputs[field.sourceOutput],
                                value: aResult[field.sourceOutput]
                            });
                        }
                    }
                }
            } else if (field.targetParameterIsGlobal) {
                self.piping.parameters.globals.setValue(field.targetParameter, aResult ? aResult[field.sourceOutput] : null);
            } else {
                self.piping.parameters.locals.setValue(field.targetParameter, aResult ? aResult[field.sourceOutput] : null);
            }
        });

        var listeners = this.piping.datasources.getDatasourceListenersThatListenForWithDefaultParams(this.mapping.dataSource.id);

    	_.each(listeners, function (listener) {
    	    listener.handler(queryResult);
    	});
    };

    Mapping.prototype._doMappingFromViewModel = function () {
        var self = this;
        _.each(this.mapping.fields, function (field) {
            var sourceMorph = self.piping.dropFactory.findDropByViewModelKey(field.sourceViewModelKey);
    		if (sourceMorph) {
    		    var value = sourceMorph.getValue();
    		    self._mapValue(field, value);
    		}
    	});
    };

    Mapping.prototype._doMappingFromParameter = function () {
        var self = this;
    	_.each(this.mapping.fields, function (field) {
            var value = self.piping.parameters.getValue(field.sourceParameter);
    	    self._mapValue(field, value);
	    });
    };

    Mapping.prototype._doMappingFromQueryString = function () {
        var self = this;
        _.each(this.mapping.fields, function (field) {
            var value = self.piping.queryString.getValueOf(field.sourceParameter);
            self._mapValue(field, value);
        });
    };

    Mapping.prototype._doMappingFromFixedValue = function () {
        var self = this;
        _.each(this.mapping.fields, function (field) {
            self._mapValue(field, field.sourceValue);
        });
    };

    Mapping.prototype._doMappingFromNullValue = function () {
        var self = this;
        _.each(this.mapping.fields, function (field) {
            self._mapValue(field, null);
        });
    };

    Mapping.prototype._mapValue = function (field, value) {
        if (field.targetViewModelKey) {
            this.mapToView(field, value);
        }
        else if (field.targetParameter) {
            this.mapToParameter(field, value);
        }
        else if (field.isToUrl) {
            this.mapToUrl(field, value);
        }
    };

    Mapping.prototype.mapToView = function (field, value) {
        var targetMorph = this.piping.dropFactory.findDropByViewModelKey(field.targetViewModelKey);
        if (targetMorph) {
            if (value === null || value === undefined || value === NaN || value === "") {
                targetMorph.clearValue();
            } else {
                targetMorph.setValue({
                    type: types.getTypeOfValue(value),
                    value: value
                });
            }
        }
    };

    Mapping.prototype.mapToParameter = function (field, value) {
        if (field.targetParameterIsGlobal) {
            this.piping.parameters.globals.setValue(field.targetParameter, value);
        } else {
            this.piping.parameters.locals.setValue(field.targetParameter, value);
        }
    };

    Mapping.prototype.mapToUrl = function (field, value) {
        var url = new URL(window.location.href);
        var state = window.history.state;

        if (this.piping.parameters.globals.parameterExists(field.sourceParameter)) {
            var globals = url.searchParams.has("globals") ? JSON.parse(url.searchParams.get("globals")) : {};
            globals[field.sourceParameter] = value;
            url.searchParams.set("globals", JSON.stringify(globals));
        }
        if (this.piping.parameters.locals.parameterExists(field.sourceParameter)) {
            var parameters = url.searchParams.has("parameters") ? JSON.parse(url.searchParams.get("parameters")) : {};
            parameters[field.sourceParameter] = value;
            url.searchParams.set("parameters", JSON.stringify(parameters));
        }
        window.history.replaceState(state, "", url);
    };

    return Mapping;
});
